import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getDevice } from '@panel/commons/helpers';
import SnackBarContainer from '@panel/commons/lib/SimpleSnackbar/SnackBarContainer';
import StepMain from './components/Steps/Main';
import StepLocation from './components/Steps/Location';
import StepFeatures from './components/Steps/Features';
import StepMultimedia from './components/Steps/Multimedia';
import StepExtras from './components/Steps/Extras';
import StepDescription from './components/Steps/Description';
import PriceStep from './components/Steps/Price';
import StepPublish from './components/Steps/Publish';
import EditionView from './components/EditionView';
import PublicationType from './components/PublicationType';
import SuccessfulPublication from './components/SuccessfulPublication';
import { StepperSelectors } from './ducks/stepper';
import useScrollToTop from './hooks/useScrollToTop';

const NotFound = React.lazy(() => import('@panel/core/src/sections/notFound/notFound'));

const PublicadorProfesionales = () => {
  const { snackAction } = useSelector(StepperSelectors.getStepperState);
  useScrollToTop(); // Hook personalizado para hacer scroll al top en cada cambio de ruta

  return (
    <>
      <SnackBarContainer action={snackAction} deviceType={getDevice()} withAlertIcon={false} />
      <Switch>
        <Route path='/publicador-profesionales' exact>
          <PublicationType />
        </Route>
        <Route path='/publicador-profesionales/main'>
          <StepMain />
        </Route>
        <Route path='/publicador-profesionales/location'>
          <StepLocation />
        </Route>
        <Route path='/publicador-profesionales/multimedia'>
          <StepMultimedia />
        </Route>
        <Route path='/publicador-profesionales/features'>
          <StepFeatures />
        </Route>
        <Route path='/publicador-profesionales/extras'>
          <StepExtras />
        </Route>
        <Route path='/publicador-profesionales/description'>
          <StepDescription />
        </Route>
        <Route path='/publicador-profesionales/price'>
          <PriceStep />
        </Route>
        <Route path='/publicador-profesionales/publish'>
          <StepPublish />
        </Route>
        <Route path='/publicador-profesionales/successfulPublication'>
          <SuccessfulPublication />
        </Route>
        <Route path='/publicador-profesionales/edition'>
          <EditionView />
        </Route>
        <Route path='/*'>
          <NotFound />
        </Route>
      </Switch>
    </>
  );
};

export { PublicadorProfesionales };
